export const DESCOPE_BASE_URL = 'https://auth.app.clearitty.com';

export const DESCOPE_SESSION_COOKIE = 'DS';
export const DESCOPE_REFRESH_COOKIE = 'DSR';

export const DESCOPE_COOKIE_OPTIONS = {
    sameSite: 'Lax',
    secure: process.env.NODE_ENV !== 'development',
} as const;
